import { Modal } from 'components/Modal';
import { useContext, useEffect } from 'react';
import { Button } from 'components/Button';
import { ModalBody } from 'components/Modal/ModalBody';
import { ModalActions } from 'components/Modal/ModalActions';
import isBoolean from 'lodash/isBoolean';
import noop from 'lodash/noop';
import { HiringUpdateFlowContext } from 'features/EmployerHiringUpdateFlow/EmployerHiringUpdateContext';
import { HiringUpdateFlowSteps } from 'features/EmployerHiringUpdateFlow/EmployerHiringUpdateFlow.constants';
import { HiredUser } from 'features/EmployerHiringUpdateFlow/HiredUser';

export const NewHireConfirmationStep = () => {
  const { open, userProfile, step, goToNextStep, hireConfirmed, setHireConfirmed } =
    useContext(HiringUpdateFlowContext);

  const handleConfirmHire = () => {
    setHireConfirmed(true);
  };

  const handleDenyHire = () => {
    setHireConfirmed(false);
  };

  useEffect(() => {
    if (isBoolean(hireConfirmed)) {
      goToNextStep();
    }
  }, [hireConfirmed]);

  useEffect(() => {
    if (step === HiringUpdateFlowSteps.TEACHER_HIRE_CONFIRMATION) {
      setHireConfirmed(null);
    }
  }, [step]);

  return (
    <Modal
      panelProps={{
        className: 'sm:!max-w-[456px]',
      }}
      open={open && step === HiringUpdateFlowSteps.TEACHER_HIRE_CONFIRMATION}
      heading={<span className="text-primary-pure-blue">New hire reported! 😉</span>}
      onClose={noop}
      actionRequired
    >
      <ModalBody>
        <p className="text-sm text-neutral-ink-blue text-center mx-auto max-w-[325px] font-bold">
          Could you please confirm that the below person was hired by you or someone on your team?
        </p>

        <HiredUser userProfile={userProfile} />
      </ModalBody>

      <ModalActions>
        <Button type="button" size="lg" fullWidth onClick={handleConfirmHire}>
          Yes, I hired them!
        </Button>
        <Button
          type="button"
          size="lg"
          variant="outline"
          onClick={handleDenyHire}
          fullWidth
          color="poppy-red"
        >
          No, I didn&apos;t hire them
        </Button>
      </ModalActions>
    </Modal>
  );
};
